'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Form = require('material-ui/Form');

var _Checkbox = require('material-ui/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = function Checkbox(_ref) {
  var input = _ref.input,
      label = _ref.label,
      disabled = _ref.disabled,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error;
  return _react2.default.createElement(
    'div',
    { style: { float: 'left', maxWidth: '100%' } },
    _react2.default.createElement(_Form.FormControlLabel, {
      style: { textAlign: 'left' },
      control: _react2.default.createElement(_Checkbox2.default, {
        disabled: disabled,
        checked: Boolean(input.value),
        onChange: input.onChange
      }),
      label: _react2.default.createElement(
        'div',
        null,
        label,
        touched && error ? _react2.default.createElement(
          _Form.FormHelperText,
          { error: true },
          error
        ) : null
      )
    })
  );
};

Checkbox.propTypes = {
  input: _propTypes2.default.object.isRequired,
  label: _propTypes2.default.node.isRequired,
  meta: _propTypes2.default.object.isRequired,
  disabled: _propTypes2.default.bool
};

Checkbox.defaultProps = {
  disabled: false
};

exports.default = Checkbox;